import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-inline-spinner',
  templateUrl: './inline-spinner.component.html',
  styleUrls: ['./inline-spinner.component.scss']
})
export class InlineSpinnerComponent {
  @Input() size: 'xs' | 'sm' | 'md' = 'sm';
  @Input() color: 'blue' | 'white' | 'grey' = 'blue';
}
